import { initComponentStore, noop } from "@/utils/mobx";


export interface SelectInputOption {
    title: string;
    value: string;
    isDisabled?: boolean;
}

export class SelectInputStore {
    value: string | null = null;
    options: SelectInputOption[] | null = null;
    isPopupVisible: boolean = false;
    onChange: ((value: string | null) => any) | null = null;
    className: string = "";
    placeholder: string = "";

    constructor() {
        initComponentStore(this);
    }

    togglePopup() {
        this.isPopupVisible = !this.isPopupVisible;
    }

    hidePopup() {
        this.isPopupVisible = false;
    }

    changeValue(value: string | null) {
        if (this.onChange) {
            this.onChange(value);
        } else {
            this.value = value;
        }
        this.isPopupVisible = false;
    }

    getTitle(value: string | null): string {
        try {
            return this.options!.filter((o) => o.value === value)[0].title;
        } catch {
            return value ?? "";
        }
    }
}
